import { render, staticRenderFns } from "./SalonBottomMenu.vue?vue&type=template&id=2525a02d&scoped=true"
import script from "./SalonBottomMenu.vue?vue&type=script&lang=js"
export * from "./SalonBottomMenu.vue?vue&type=script&lang=js"
import style0 from "./SalonBottomMenu.vue?vue&type=style&index=0&id=2525a02d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525a02d",
  null
  
)

export default component.exports